<template>
  <div class="field is-horizontal">
    <div class="field-body">
      <div class="field" v-if="isFlowReportDisplayed">
        <FlowReportFilters />
      </div>
      <div class="field">
        <DateRangeFilter v-if="!isUsageReportDisplayed" />
        <UsageDateRangeFilter v-if="isUsageReportDisplayed" />
      </div>
      <div class="field">
        <ReportDownloader />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import FlowReportFilters from '@/features/reports/components/flows/FlowReportFilters.vue';
import DateRangeFilter from '@/features/reports/components/DateRangeFilter.vue';
import ReportDownloader from '@/features/reports/components/ReportDownloader.vue';
import UsageDateRangeFilter from '@/features/reports/components/usage/UsageDateRangeFilter.vue';
import { computed } from 'vue';

const activeRoute = useRoute();

const isFlowReportDisplayed = computed(() => activeRoute.name === 'reports-flows');
const isIntentsReportDisplayed = computed(() => activeRoute.name === 'reports-intents');
const isUsageReportDisplayed = computed(() => activeRoute.name === 'reports-usage');
</script>
